// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumWorkmarkOutlinedSvg from "@fishx/icons-svg/es/asn/MediumWorkmarkOutlined";
import FishxIcon from '../components/FishxIcon';

var MediumWorkmarkOutlined = function MediumWorkmarkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumWorkmarkOutlinedSvg
  }));
};

MediumWorkmarkOutlined.displayName = 'MediumWorkmarkOutlined';
export default React.forwardRef(MediumWorkmarkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MediumWorkmarkOutlined.js
// module id = 3110
// module chunks = 0